import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const businessPerformanceClientsColumns = (intl = null, es = false) => [
  {
    className: "companyName",
    dataIndex: "companyName",
    key: "companyName"
  },

  {
    className: "dataColumn",
    title: intl?.formatMessage({id: "permissions.Fatturato clienti"}) || "Fatturato Clienti",
    dataIndex: "FatturatoTotale",
    key: "fatturatoClienti",
    render: (fatturatoClienti) =>
      fatturatoClienti === true ? (
        <FontAwesomeIcon
          icon={["fas", "check-circle"]}
          style={{
            color: "#09822a",
            fontSize: "14px"
          }}
        />
      ) : (
        <FontAwesomeIcon
          icon={["fas", "minus-circle"]}
          style={{
            color: "#d82829",
            fontSize: "14px"
          }}
        />
      )
  },
  {
    className: "dataColumn",
    title: intl?.formatMessage({id: "permissions.Margine sul fatturato"}) || "Margine sul fatturato",
    dataIndex: "MargineSulVendutoTotale",
    key: "margineSulFatturato",
    render: (margineSulFatturato) =>
      margineSulFatturato === true ? (
        <FontAwesomeIcon
          icon={["fas", "check-circle"]}
          style={{
            color: "#09822a",
            fontSize: "14px"
          }}
        />
      ) : (
        <FontAwesomeIcon
          icon={["fas", "minus-circle"]}
          style={{
            color: "#d82829",
            fontSize: "14px"
          }}
        />
      )
  },
  //     {
  //         className: "dataColumn",
  //         title: "Ordini clienti scaduti",
  //         dataIndex: "OrdiniClientiScaduti",
  //         key: "ordiniClientiScaduti",
  //         render: ordiniClientiScaduti => ordiniClientiScaduti === true ?  <FontAwesomeIcon
  //             icon={["fas", "check-circle"]}
  //             style={{
  //                     color: "#09822a",
  //                     fontSize: "14px"
  //             }}/> :  <FontAwesomeIcon
  //             icon={["fas", "minus-circle"]}
  //             style={{
  //                     color: "#d82829",
  //                     fontSize: "14px"
  //             }}/>
  //     },
  {
    className: "dataColumn",
    title: intl?.formatMessage({id: "permissions.Fatturato consolidato, DDT emessi e ordini residui"}) || "Fatturato consolidato, DDT emessi e ordini residui",
    dataIndex: "FatturatoDaFatturareOrdiniDaEvadere",
    key: "fatturatoConsolidato",
    render: (fatturatoConsolidato) =>
      fatturatoConsolidato === true ? (
        <FontAwesomeIcon
          icon={["fas", "check-circle"]}
          style={{
            color: "#09822a",
            fontSize: "14px"
          }}
        />
      ) : (
        <FontAwesomeIcon
          icon={["fas", "minus-circle"]}
          style={{
            color: "#d82829",
            fontSize: "14px"
          }}
        />
      )
  },
  {
    className: "dataColumn",
    title: intl?.formatMessage({id: "permissions.Venduto clienti"}) || "Venduto clienti",
    dataIndex: "VendutoTotale",
    key: "vendutoClienti",
    render: (vendutoClienti) =>
      vendutoClienti === true ? (
        <FontAwesomeIcon
          icon={["fas", "check-circle"]}
          style={{
            color: "#09822a",
            fontSize: "14px"
          }}
        />
      ) : (
        <FontAwesomeIcon
          icon={["fas", "minus-circle"]}
          style={{
            color: "#d82829",
            fontSize: "14px"
          }}
        />
      )
  },
  {
    className: "dataColumn",
    title: intl?.formatMessage({id: "permissions.Margine sull'ordinato"}) || "Margine sull'ordinato",
    dataIndex: "MargineSuOrdiniTotale",
    key: "margineOrdinato",
    render: (margineOrdinato) =>
      margineOrdinato === true ? (
        <FontAwesomeIcon
          icon={["fas", "check-circle"]}
          style={{
            color: "#09822a",
            fontSize: "14px"
          }}
        />
      ) : (
        <FontAwesomeIcon
          icon={["fas", "minus-circle"]}
          style={{
            color: "#d82829",
            fontSize: "14px"
          }}
        />
      )
  }
];

export const businessPerformanceProvidersColumns = (intl = null, es = false) => [
  {
    className: "companyName",
    dataIndex: "companyName",
    key: "companyName"
  },
  {
    className: "dataColumn",
    title: intl?.formatMessage({id: "permissions.Fatturato fornitori"}) || "Fatturato fornitori",
    dataIndex: "AcquistatoTotale",
    key: "fatturatoFornitori",
    render: (fatturatoFornitori) =>
      fatturatoFornitori === true ? (
        <FontAwesomeIcon
          icon={["fas", "check-circle"]}
          style={{
            color: "#09822a",
            fontSize: "14px"
          }}
        />
      ) : (
        <FontAwesomeIcon
          icon={["fas", "minus-circle"]}
          style={{
            color: "#d82829",
            fontSize: "14px"
          }}
        />
      )
  },
  {
    className: "dataColumn",
    title: intl?.formatMessage({id: "permissions.Ripartizione beni e servizi"}) || "Ripartizione beni e servizi",
    dataIndex: "AcquistatoBeniServizi",
    key: "ripartizioneBeniServizi",
    render: (ripartizioneBeniServizi) =>
      ripartizioneBeniServizi === true ? (
        <FontAwesomeIcon
          icon={["fas", "check-circle"]}
          style={{
            color: "#09822a",
            fontSize: "14px"
          }}
        />
      ) : (
        <FontAwesomeIcon
          icon={["fas", "minus-circle"]}
          style={{
            color: "#d82829",
            fontSize: "14px"
          }}
        />
      )
  },
  {
    className: "dataColumn",
    title: intl?.formatMessage({id: "permissions.Ordini emessi a fornitori "}) || "Ordini emessi a fornitori",
    dataIndex: "OrdiniFornitoriTotale",
    key: "ordiniEmessiFornitori",
    render: (ordiniEmessiFornitori) =>
      ordiniEmessiFornitori === true ? (
        <FontAwesomeIcon
          icon={["fas", "check-circle"]}
          style={{
            color: "#09822a",
            fontSize: "14px"
          }}
        />
      ) : (
        <FontAwesomeIcon
          icon={["fas", "minus-circle"]}
          style={{
            color: "#d82829",
            fontSize: "14px"
          }}
        />
      )
  },
  {
    className: "dataColumn",
    title: intl?.formatMessage({id: "permissions.Residuo ordini fornitori"}) || "Residuo ordini fornitori",
    dataIndex: "ResiduoOrdiniFornitoriTotale",
    key: "residuoOrdiniFornitori",
    render: (residuoOrdiniFornitori) =>
      residuoOrdiniFornitori === true ? (
        <FontAwesomeIcon
          icon={["fas", "check-circle"]}
          style={{
            color: "#09822a",
            fontSize: "14px"
          }}
        />
      ) : (
        <FontAwesomeIcon
          icon={["fas", "minus-circle"]}
          style={{
            color: "#d82829",
            fontSize: "14px"
          }}
        />
      )
  },
  {
    className: "dataColumn",
    title: intl?.formatMessage({id: "permissions.Ordini fornitori scaduti"}) || "Ordini fornitori scaduti",
    dataIndex: "ResiduoOrdiniFornitoriScadutiTotale",
    key: "ordiniFornitoriScaduti",
    render: (ordiniFornitoriScaduti) =>
      ordiniFornitoriScaduti === true ? (
        <FontAwesomeIcon
          icon={["fas", "check-circle"]}
          style={{
            color: "#09822a",
            fontSize: "14px"
          }}
        />
      ) : (
        <FontAwesomeIcon
          icon={["fas", "minus-circle"]}
          style={{
            color: "#d82829",
            fontSize: "14px"
          }}
        />
      )
  },
  {
    className: "dataColumn",
    title: intl?.formatMessage({id: "permissions.Fatturato consolidato passivo, DDT ricevuti e ordini da evadere"}) || "Fatturato consolidato passivo, DDT ricevuti e ordini da evadere",
    dataIndex: "AcquistatoDdtOrdiniDaEvadere",
    key: "ordiniFornitoriScaduti",
    render: (ordiniFornitoriScaduti) =>
      ordiniFornitoriScaduti === true ? (
        <FontAwesomeIcon
          icon={["fas", "check-circle"]}
          style={{
            color: "#09822a",
            fontSize: "14px"
          }}
        />
      ) : (
        <FontAwesomeIcon
          icon={["fas", "minus-circle"]}
          style={{
            color: "#d82829",
            fontSize: "14px"
          }}
        />
      )
  }
];

export const businessPerformancePortfolioColumns = (intl = null, es = false) => [
  {
    className: "companyName",
    dataIndex: "companyName",
    key: "companyName"
  },
  {
    className: "dataColumn",
    title: intl?.formatMessage({id: "permissions.Scadenze attive totali"}) || "Scadenze attive totali",
    dataIndex: "ScadenzeAttiveTotali",
    key: "scadenzeAttiveTotali",
    render: (scadenzeAttiveTotali) =>
      scadenzeAttiveTotali === true ? (
        <FontAwesomeIcon
          icon={["fas", "check-circle"]}
          style={{
            color: "#09822a",
            fontSize: "14px"
          }}
        />
      ) : (
        <FontAwesomeIcon
          icon={["fas", "minus-circle"]}
          style={{
            color: "#d82829",
            fontSize: "14px"
          }}
        />
      )
  },
  {
    className: "dataColumn",
    title: intl?.formatMessage({id: "permissions.Scadenze clienti totali"}) || "Scadenze clienti totali",
    dataIndex: "ScadenziarioAttivoClientiDataTotale",
    key: "scadenzeClientiTotali",
    render: (scadenzeClientiTotali) =>
      scadenzeClientiTotali === true ? (
        <FontAwesomeIcon
          icon={["fas", "check-circle"]}
          style={{
            color: "#09822a",
            fontSize: "14px"
          }}
        />
      ) : (
        <FontAwesomeIcon
          icon={["fas", "minus-circle"]}
          style={{
            color: "#d82829",
            fontSize: "14px"
          }}
        />
      )
  },
  {
    className: "dataColumn",
    title: intl?.formatMessage({id: "permissions.Insoluti totali"}) || "Insoluti totali",
    dataIndex: "ScadenziarioAttivoInsolutiTotale",
    key: "insolutiTotali",
    render: (insolutiTotali) =>
      insolutiTotali === true ? (
        <FontAwesomeIcon
          icon={["fas", "check-circle"]}
          style={{
            color: "#09822a",
            fontSize: "14px"
          }}
        />
      ) : (
        <FontAwesomeIcon
          icon={["fas", "minus-circle"]}
          style={{
            color: "#d82829",
            fontSize: "14px"
          }}
        />
      )
  },
  {
    className: "dataColumn",
    title: intl?.formatMessage({id: "permissions.Insoluti Clienti"}) || "Insoluti clienti",
    dataIndex: "ScadenziarioAttivoInsolutiClientiTotale",
    key: "insolutiClienti",
    render: (insolutiClienti) =>
      insolutiClienti === true ? (
        <FontAwesomeIcon
          icon={["fas", "check-circle"]}
          style={{
            color: "#09822a",
            fontSize: "14px"
          }}
        />
      ) : (
        <FontAwesomeIcon
          icon={["fas", "minus-circle"]}
          style={{
            color: "#d82829",
            fontSize: "14px"
          }}
        />
      )
  },
  {
    className: "dataColumn",
    title: intl?.formatMessage({id: "permissions.Cash flow"}) || "Cashflow",
    dataIndex: "CashFlowPerMese",
    key: "cashflow",
    render: (cashflow) =>
      cashflow === true ? (
        <FontAwesomeIcon
          icon={["fas", "check-circle"]}
          style={{
            color: "#09822a",
            fontSize: "14px"
          }}
        />
      ) : (
        <FontAwesomeIcon
          icon={["fas", "minus-circle"]}
          style={{
            color: "#d82829",
            fontSize: "14px"
          }}
        />
      )
  }
];

export const businessPerformanceStoreColumns = (intl = null, es = false) => [
  {
    className: "companyName",
    dataIndex: "companyName",
    key: "companyName"
  },
  {
    className: "dataColumn",
    title: intl?.formatMessage({id: "permissions.Valore magazzino"}) || "Valore magazzino",
    dataIndex: "MagazzinoValoreTotale",
    key: "valoreMagazzino",
    render: (valoreMagazzino) =>
      valoreMagazzino === true ? (
        <FontAwesomeIcon
          icon={["fas", "check-circle"]}
          style={{
            color: "#09822a",
            fontSize: "14px"
          }}
        />
      ) : (
        <FontAwesomeIcon
          icon={["fas", "minus-circle"]}
          style={{
            color: "#d82829",
            fontSize: "14px"
          }}
        />
      )
  },
  {
    className: "dataColumn",
    title: intl?.formatMessage({id: "permissions.Indice di rotazione"}) || "Indice di rotazione",
    dataIndex: "MagazzinoIndiceRotazioneTotale",
    key: "indiceDiRotazione",
    render: (indiceDiRotazione) =>
      indiceDiRotazione === true ? (
        <FontAwesomeIcon
          icon={["fas", "check-circle"]}
          style={{
            color: "#09822a",
            fontSize: "14px"
          }}
        />
      ) : (
        <FontAwesomeIcon
          icon={["fas", "minus-circle"]}
          style={{
            color: "#d82829",
            fontSize: "14px"
          }}
        />
      )
  }
];
